(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-recently-viewed"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('collection-recently-viewed')) {
  customElements.define('collection-recently-viewed', class extends HTMLElement {
    async connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      try {
        const stored = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
        if (!Array.isArray(stored)) return;
        const ids = [...new Set(stored.map(String).filter(id => /^\d+$/.test(id)))].slice(0, 4);
        if (!ids.length) return;
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.searchParams.set('q', ids.map(id => 'id:' + id).join(' OR '));
        url.searchParams.set('type', 'product');
        url.searchParams.set('section_id', 'collection-recently-viewed');
        const response = await fetch(url);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = this.querySelector('[data-products]');
        for (const id of ids) {
          const card = doc.querySelector('[data-product-id="' + id + '"]');
          if (card) grid.append(card);
        }
        if (grid.children.length) this.querySelector('[data-empty]').hidden = true;
      } catch {}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
